import {useNavigate, useParams} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {Card, CardContent, Chip, linearProgressClasses, NativeSelect, Tooltip} from "@mui/material";
import MDBox from "../../components/MDBox";
import CustomerHeader from "../common/CustomerHeader";
import Footer from "../Footer";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import Grid from "@mui/material/Grid";
import MDTypography from "../../components/MDTypography";
import Divider from "@mui/material/Divider";
import MDInput from "../../components/MDInput";
import {
  displayPhone,
  formatAge,
  formatCurrency,
  formatDate,
  getPreferenceValue,
  handleDefaultValues
} from "../common/Utils";
import {useForm} from "react-hook-form";
import {
  customerSaveClientAccount,
  deleteMyCustomerFamily, getCustomerInvoice, getInventoryEvent, getMyMemberPerks,
  getMyProfile,
  getStates,
  saveMyCustomerFamily,
  saveMyProfile
} from "../common/api/PortalCustomerApi";
import MDButton from "../../components/MDButton";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import Confirm from "../common/Confirm";
import ClientMembershipsModal from "./modal/ClientMembershipsModal";
import ClientPurchaseHistoryModal from "./modal/ClientPurchaseHistoryModal";
import ClientManageAccountModal from "./modal/ClientManageAccountModal";
import PageLoading from "../common/PageLoading";
import ManageFamilyMemberModal from "./ManageFamilyMemberModal";
import {CompanyContext} from "../../lib/CompanyProvider";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CustomerGiftCardsMiniPane from "./pane/CustomerGiftCardsMiniPane";
import CustomerBillingMethodsPane from "./pane/CustomerBillingMethodsPane";
import ReplayIcon from '@mui/icons-material/Replay';
import AddIcon from '@mui/icons-material/Add';
import {CartContext} from "../../lib/CartProvider";
import {UserContext} from "../../lib/UserProvider";
import CustomerPerksCardsMiniPane from "./pane/CustomerPerksMiniPane";
import InfoIcon from '@mui/icons-material/Info';
import Meta from "../common/Meta";
import LockPersonIcon from '@mui/icons-material/LockPerson';

export default function CustomerProfile(props) {
  const [context, setContext] = useContext(AppContext);
  const [userContext, setUserContext] = useContext(UserContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [cartContext, setCartContext] = useContext(CartContext);
  const [pageReady, setPageReady] = useState(false);

  const [viewInvoice, setViewInvoice] = useState(props?.viewInvoice);
  let {invoiceGuid} = useParams();

  useEffect(() => {
    if (userContext?.refreshIdentity) {
      setRefreshMember(true);
    }
  }, [userContext?.refreshIdentity]);

  useEffect(() => {
    if (userContext.sessionUser?.userTypeId) {
      let showLogin = !userContext?.sessionUser?.guid?.length > 0;
      setUserContext({...userContext, showLogin: showLogin, loginNag: true});
      setPageReady(!showLogin);
    }
  }, [userContext?.sessionUser]);

  const [invoice, setInvoice] = useState(null);

  const getInvoiceFn = async () => {
    getCustomerInvoice(invoiceGuid).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInvoice(result)
        setCartContext({...cartContext, invoice: result, reloadCart: false, viewCart: true, caller: 'View invoice'});
      }
    });
  }

  useEffect(() => {
    if (!pageReady) {
      return;
    }
    if (!invoiceGuid) {
      return;
    }

    getInvoiceFn(invoiceGuid);

  }, [pageReady, invoiceGuid]);

  const [company, setCompany] = useState();
  const [states, setStates] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [statesReady, setStatesReady] = useState(false);
  const [renderIndex, setRenderIndex] = useState(1);
  const [familyMember, setFamilyMember] = useState(null);
  const [manageFamilyMember, setManageFamilyMember] = useState(false);
  const [managePaymentMethod, setManagePaymentMethod] = useState(false);

  const [confirmation, setConfirmation] = useState(null);
  const [confirmDeleteFamilyMember, setConfirmDeleteFamilyMember] = useState(false);
  const [saving, setSaving] = useState(false);
  const [refreshMember, setRefreshMember] = useState(false);
  const [showMembershipModal, setShowMembershipModal] = useState(false);
  const [showPurchaseHistory, setShowPurchaseHistory] = useState(false);
  const [reservations, setReservations] = useState([]);
  const [perks, setPerks] = useState([]);

  const [inventory, setInventory] = useState();

  const [memberAccount, setMemberAccount] = useState(null);
  const [manageMemberAccount, setManageMemberAccount] = useState(false);


  const navigate = useNavigate();
  const myRefs = useRef([]);

  const manageMemberAccountFn = (account) => {
    setMemberAccount(account);
    setManageMemberAccount(true)
  };

  const refHandler = (index) => {
    myRefs.current[index].visible = !!!myRefs.current[index].visible;
    setRenderIndex(renderIndex + 1);
  };
  const manageFamilyMemberFn = (member) => {
    let m = null;
    if (member) {
      m = {...member};
    }
    setFamilyMember(m);
    setManageFamilyMember(true);
  };

  const handleCloseInventoryMembershipModal = () => {
    setShowMembershipModal(false);
  }

  const handleClosePurchaseHistory = () => {
    setShowPurchaseHistory(false);
  }

  const handleCloseManageAccount = () => {
    setManageMemberAccount(false);
  }

  const handleSaveMemberAccount = async (account) => {

    setSaving(true);

    let result = await customerSaveClientAccount(account);
    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setManageMemberAccount(false);
    }
  }

  const manageMembershipFn = (member) => {
    setShowMembershipModal(true);
  };


  const handleCancelFamilyMember = () => {
    setConfirmation(null);
    setConfirmDeleteFamilyMember(false);
  }

  const handleConfirmFamilyMember = async (familyMember) => {
    setSaving(true);
    setConfirmDeleteFamilyMember(false);
    let result = await deleteMyCustomerFamily(familyMember);
    setSaving(false);
    setConfirmation(null);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setConfirmDeleteFamilyMember(false);
    }
  }

  const preDeleteFamilyMemberFn = (member) => {
    let confirmation = {
      title: 'Delete ' + member.firstName + '?',
      message: 'Delete ' + member.firstName + ' ' + member.lastName + ' Permanently?',
      entity: member
    }
    setConfirmation(confirmation);
    setConfirmDeleteFamilyMember(true);
  };
  const {register, handleSubmit, setValue, control, reset} = useForm({
    values: handleDefaultValues(customer),
  });

  const saveProfile = (profile) => {

    if (profile.passwd?.length > 0) {
      if (profile.passwd !== profile.passwd2) {
        alert("Passwords do not match!");
        return;
      }
    }
    setSaving(true);
    saveMyProfile(profile).then(result => {
      getMyProfile().then(result => {
        setRenderIndex(renderIndex + 1);
        setCustomer(result);
        setPageReady(true);
        setSaving(false);
      });
    });
  }
  useEffect(() => {
    getStates().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setStates(result);
        setStatesReady(true);
      }
    });
    setRefreshMember(true);
  }, []);

  useEffect(() => {
    if (!userContext?.sessionUser?.guid) {
      return;
    }
    setRefreshMember(true);
  }, [userContext?.sessionUser?.guid]);

  const handleCloseFamilyMember = () => {
    setFamilyMember(null);
    setManageFamilyMember(false);
  }

  useEffect(() => {
    if (!refreshMember) {
      return;
    }
    setRefreshMember(false);
    getMyProfile().then(result => {
      setCustomer(result);
      setUserContext({...userContext, sessionUser: result});
    });

    getMyMemberPerks().then((result) => {
      setPerks(result);
    })

  }, [refreshMember]);

  const handleSaveFamilyMember = async (member) => {

    setSaving(true);

    let result = await saveMyCustomerFamily(member);
    setFamilyMember(null);
    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setManageFamilyMember(false);
    }
  }

  useEffect(() => {
    if (companyContext?.company?.guid?.length && userContext?.sessionUser?.guid?.length) {
      setPageReady(true);
      setCompany(companyContext.company);
    }
  }, [companyContext?.company]);

  const MembershipItemActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
             <MoreHorizIcon/>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              disabled={item.pendingCancellation}
              onClick={(e) => {
                manageMemberAccountFn(item)
              }} icon={<CancelIcon/>} title={item?.pendingCancellation ? 'Pending Cancellation' : 'Cancel'}/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const ProgressBar = ({account}) => {
    let usage = 0;
    let numberVisits = account?.accountType?.numberVisits;
    let totalUsed = account?.numberVisits;
    if (totalUsed > numberVisits) {
      usage = 100;
    }
    usage = Math.ceil((totalUsed / numberVisits) * 100);
    return (<div>
      <div style={{
        width: '100%',
        background: '#B8D1F6FF',
        height: '16px',
        borderRadius: '10px',
      }}>
        <div className="w3-grey" style={{
          width: usage + '%',
          maxWidth: '100%',
          background: '#778dac',
          height: '16px',
          borderRadius: '10px'
        }}></div>
      </div>
      <p className={'mt-2'}>Visits Remaining {totalUsed} / {numberVisits}</p>
    </div>)
  }

  const [passChange, setPassChange] = useState(false);

  const FamilyMemberItemActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
             <MoreHorizIcon/>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                manageFamilyMemberFn(item)
              }} icon={<EditIcon/>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              preDeleteFamilyMemberFn(item)
            }} icon={<HighlightOffIcon/>} title="Delete"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  return (
    <CustomerPageLayout>
      <Meta pageTitle={viewInvoice ? 'View Invoice' : 'Customer Profile'}/>
      <CustomerHeader props={props}/>
      <MDBox m={1} p={1}>
        <h1>
          {companyContext?.company?.preferences && getPreferenceValue(companyContext?.company?.preferences, 'menu_item_my_profile', 'My Profile')}
          <MDButton
            color="info"
            size="small"
            style={{
              float: 'right'
            }}
            onClick={(e) => {
              navigate('/cx/my-purchases');
            }}>
            <AttachMoneyIcon/>&nbsp;Purchase History
          </MDButton>
          <Divider/>
        </h1>

        {pageReady && <MDBox>
          <MDBox>
            <Grid container cols={2} spacing={3} direction="row">
              <Grid item xs={12} sm={8}>
                <Card>
                  <CardContent>

                    {!customer && <PageLoading/>}
                    {customer &&
                      <form onSubmit={handleSubmit(saveProfile)} id={'myProfileForm'}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <div className="form-group">
                              <MDInput type="text" required
                                       {...register('firstName')}

                                       variant="outlined"
                                       InputLabelProps={{shrink: true}}
                                       placeholder="Enter First Name"
                                       label="First name"

                                       className="form-control" id="firstName"
                              />
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <div className="form-group">
                              <MDInput type="text" required
                                       {...register('lastName')}
                                       variant="outlined"
                                       InputLabelProps={{shrink: true}}
                                       placeholder="Enter Last Name"

                                       className="form-control" id="lastName"
                                       label="Enter Last name"/>
                            </div>

                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <div className="form-group">
                              <MDInput
                                variant="outlined"
                                type="email" required
                                {...register('email')}
                                variant="outlined"
                                InputLabelProps={{shrink: true}}
                                placeholder="Enter Email"
                                className="form-control" id="email"
                                label="Enter Email"/>

                              <label htmlFor="emailEnabled" className={'mt-2'}>
                                <input type="checkbox"
                                       {...register('emailEnabled')}

                                       id="emailEnabled"/>
                                &nbsp;Email Allowed
                              </label>
                            </div>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <div className="form-group">
                              <MDInput
                                variant="outlined" type="text"
                                {...register('primaryPhone', {
                                  required: 'true' === context?.sessionUser?.company?.preferences['require_phone'],
                                  onChange: (e) => {
                                    e.target.value = displayPhone(e.target.value);
                                  }
                                })}
                                required={'true' === context?.sessionUser?.company?.preferences['require_phone']}
                                InputLabelProps={{shrink: true}}
                                placeholder="Enter Phone"
                                className="form-control" id="primaryPhone"
                                label="Enter Phone"/>

                              <label htmlFor="smsEnabled" className={'mt-2'}>
                                <input type="checkbox"
                                       {...register('smsEnabled')}
                                       id="smsEnabled"/>
                                &nbsp;Texts Allowed
                              </label>
                            </div>
                          </Grid>


                          <Grid item xs={12} sm={6}>
                            <div className="form-group">
                              <MDInput type="password" required={passChange}
                                       {...register('passwd', {
                                         onChange: (e) => {
                                           setPassChange(e.target.value?.length > 0)
                                         }
                                       })}
                                       autoComplete="off"
                                       variant="outlined"
                                       className="form-control" id="passwd"
                                       InputLabelProps={{shrink: true}}
                                       placeholder="Password"
                                       label="Enter Password"/>
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <div className="form-group">
                              <MDInput type="password" required={passChange}
                                       {...register('passwd2')}
                                       autoComplete="off"
                                       variant="outlined"
                                       className="form-control" id="passwd2"
                                       InputLabelProps={{shrink: true}}
                                       placeholder="Confirm Password"
                                       label="Re-Enter Password"/>
                            </div>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <div className="form-group">
                              <MDInput
                                variant="outlined" type="text"
                                {...register('address1', {
                                  required: 'true' === context?.sessionUser?.company?.preferences['require_address']
                                })}
                                required={'true' === context?.sessionUser?.company?.preferences['require_address']}
                                InputLabelProps={{shrink: true}}
                                placeholder="Enter Address"
                                className="form-control" id="address1"
                                label="Enter Address"/>
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <div className="form-group">
                              <MDInput
                                variant="outlined" type="text"
                                {...register('address2', {})}
                                InputLabelProps={{shrink: true}}
                                placeholder="Enter Address 2"
                                className="form-control" id="address2"
                                label="Enter Address 2"/>
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <div className="form-group">
                              <MDInput
                                variant="outlined" type="text"
                                {...register('city', {
                                  required: 'true' === context?.sessionUser?.company?.preferences['require_address']
                                })}
                                required={'true' === context?.sessionUser?.company?.preferences['require_address']}
                                InputLabelProps={{shrink: true}}
                                placeholder="Enter City"
                                className="form-control" id="city"
                                label="Enter City"/>
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <div className="form-group">
                              {states && <NativeSelect
                                variant="outlined"
                                id={'state'} name={'state'} className={'form-control'}
                                {...register('state.stateId', {
                                  required: 'true' === context?.sessionUser?.company?.preferences['require_address']
                                })}
                                required={'true' === context?.sessionUser?.company?.preferences['require_address']}>
                                {
                                  states.map((c) =>
                                    <option value={c.stateId} key={c.stateId}>
                                      {c.stateName}
                                    </option>)
                                }
                              </NativeSelect>}
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <div className="form-group">
                              <MDInput
                                variant="outlined" type="text"
                                {...register('zipCode', {
                                  required: 'true' === context?.sessionUser?.company?.preferences['require_address']
                                })}
                                required={'true' === context?.sessionUser?.company?.preferences['require_address']}
                                InputLabelProps={{shrink: true}}
                                placeholder="Enter Zip"
                                className="form-control" id="zipCode"
                                label="Enter Zip"/>
                            </div>
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid item xs={12} py={2}>
                            <MDButton
                              type="submit"
                              variant="gradient"
                              size={'medium'}
                              disabled={saving}
                              color="secondary">
                              {saving ? 'Saving Profile' : 'Save Profile'}
                            </MDButton>
                          </Grid>
                        </Grid>

                      </form>
                    }
                  </CardContent>
                </Card>
                <Card sx={{marginTop: '15px'}}>
                  <CardContent>
                    <MDTypography variant="h5" color="secondary" fontWeight="light">
                      Family Members
                      <MDButton
                        color="secondary"
                        size="small"
                        style={{
                          float: 'right'
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          manageFamilyMemberFn(null)
                        }}>
                        <PersonAddIcon/>&nbsp;Add Family
                      </MDButton>
                      <Divider/>
                    </MDTypography>

                    <MDTypography variant="p" color="text" fontWeight="regular">
                      <ul className={'list-group'}>


                        {renderIndex && customer?.familyMembers?.sort((a, b) => a.id > b.id ? 1 : -1)
                          .map((familyMember, index) => {
                            return (<li className={'list-group-item'}
                                        style={{
                                          'position': 'relative',
                                        }}
                                        key={index}>

                            <span style={{float: 'right', position: 'relative', zIndex: 2}}>
                                <FamilyMemberItemActions item={familyMember}/>
                               </span>

                              <span className={'cursor-pointer'} onClick={(e) => {
                                manageFamilyMemberFn(familyMember)
                              }}>{familyMember.firstName} {familyMember.lastName}

                                <span className={'font-smaller'}>
                                      {familyMember?.dob && ' (' + formatAge(familyMember) + ')'}
                                    </span>
                                  </span>
                              <br/>
                              <Chip
                                variant="outlined"
                                color="secondary"
                                label={familyMember.familyMemberType.name}/>&nbsp;

                              {familyMember.emergencyContact &&
                                <>
                                  <Chip
                                    variant="outlined"
                                    color="primary"
                                    label={'Emergency Contact ' + displayPhone(familyMember.phoneNumber)}
                                  />&nbsp;
                                </>
                              }
                            </li>)
                          })}
                      </ul>
                    </MDTypography>
                  </CardContent>
                </Card>
              </Grid>


              <Grid item sm={4} xs={12}>

                {viewInvoice && invoice && <MDBox>
                  <Grid container cols={2} spacing={1} direction="row">
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          <MDTypography variant="h5" fontWeight="light">
                            Pending Invoice - {invoice.referenceId}
                          </MDTypography>
                          <MDTypography variant="p">
                            Amount Due: {formatCurrency(invoice.amountDue)}
                          </MDTypography>
                          <br/>
                          <MDButton color={"primary"}
                                    size="small"
                                    style={{
                                      marginTop: '6px',
                                      clear: 'both'
                                    }}
                                    onClick={(e) => {
                                      getInvoiceFn();
                                    }}>
                            Pay Invoice
                          </MDButton>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </MDBox>
                }

                <div style={{marginBottom: '15px'}}>
                  {customer && <CustomerBillingMethodsPane customer={customer} handleSave={(e) => {
                    setRefreshMember(true);
                  }}
                  />}
                </div>

                <CustomerGiftCardsMiniPane/>

                {perks?.length > 0 && <div style={{marginBottom: '15px'}}>
                  <CustomerPerksCardsMiniPane perks={perks}/>
                </div>
                }

                <MDBox>
                  <Grid container cols={2} spacing={1} direction="row">
                    <Grid item xs={12}>
                      <Card>
                        <CardContent>
                          <MDTypography variant="h5" color="secondary" fontWeight="light">
                            Memberships
                            <MDButton
                              color="secondary"
                              size="small"
                              style={{
                                float: 'right'
                              }}
                              href={'#/cx/passes'}>
                              <AddIcon/>&nbsp;Add Membership
                            </MDButton>
                            <Divider/>
                          </MDTypography>
                          <div>
                            <ul className={'list-group'}>
                              {renderIndex && customer?.accounts?.sort((a, b) => a.accountId > b.accountId ? 1 : -1)
                                .map((account, index) => {
                                  return (<li className={'list-group-item'}
                                              style={{
                                                'position': 'relative',
                                              }}
                                              key={index}>
                                    {account?.recurring &&
                                      <span style={{float: 'right', position: 'relative', zIndex: 2}}>
                                      <MembershipItemActions item={account}/>
                                   </span>}
                                    <h5>
                                      {account.name}
                                    </h5>
                                    {!account?.accountType?.unlimitedVisits && <ProgressBar account={account}/>}

                                    {account?.accountType?.recurring &&
                                      <>
                                        <Chip
                                          variant="outlined"
                                          color="secondary"
                                          label={<><ReplayIcon style={{
                                            transform: "scaleX(-1) "
                                          }}/> Recurring</>}
                                        />&nbsp;

                                        {account?.minimumMembership && <><Chip
                                          className={'pull-left m-chip'}
                                          icon={<LockPersonIcon/>}
                                          label={<>Mininum
                                            Contract {account?.minMembershipMonths} {account?.minMembershipMonths === 1 ? 'Month' : 'Months'}</>}
                                          variant="outlined"
                                        />&nbsp;</>}

                                        {account?.minimumCancellationDays && <><Chip
                                          className={'pull-left m-chip'}
                                          icon={<LockPersonIcon/>}
                                          label={<>Cancellation
                                            Notice {account?.minimumCancellationDays} {account?.minimumCancellationDays === 1 ? 'Day' : 'Days'}</>}
                                          variant="outlined"
                                        />&nbsp;</>}

                                      </>
                                    }

                                    {account?.accountType?.unlimitedVisits &&
                                      <>
                                        <Chip
                                          variant="outlined"
                                          color="secondary"
                                          label={"Unlimited Visits"}
                                        />&nbsp;
                                      </>
                                    }

                                    {account?.pendingCancellation && <>
                                      <Tooltip title={<>
                                        <h6>This membership has been canceled</h6>
                                        <p>The membership will be active through the remainder of your current
                                          billing period.</p>
                                      </>}>
                                        <>
                                          <Chip
                                            color="info"
                                            variant="outlined"
                                            label={<>Cancellation Scheduled {account?.billingEndDate &&
                                              <b>{formatDate(account.billingEndDate)}</b>}</>}
                                            onClick={() => {
                                            }}
                                            onDelete={() => {
                                            }}
                                            deleteIcon={<InfoIcon/>}
                                          />&nbsp;
                                        </>
                                      </Tooltip>
                                    </>}

                                    {account?.nextBillDate && <div className={'cls d-block'}><Chip
                                      color="secondary"
                                      variant="filled"
                                      className={'my-2'}
                                      label={'Next Billing Date: ' + formatDate(account.nextBillDate)}
                                    /></div>}

                                  </li>);
                                })}
                            </ul>
                          </div>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        }

      </MDBox>

      {showPurchaseHistory && <ClientPurchaseHistoryModal
        handleClose={handleClosePurchaseHistory}
        show={showPurchaseHistory}/>
      }
      {showMembershipModal && <ClientMembershipsModal
        handleClose={() => {
          handleCloseInventoryMembershipModal();
          setRefreshMember(true);
        }}
        handleSave={() => {
          handleCloseInventoryMembershipModal();
          setRefreshMember(true);
        }}
        show={showMembershipModal}
      />
      }


      {
        confirmation && <Confirm confirmation={confirmation}
                                 show={confirmDeleteFamilyMember}
                                 saving={saving}
                                 handleConfirm={handleConfirmFamilyMember}
                                 handleClose={handleCancelFamilyMember}/>
      }

      {
        manageFamilyMember && <ManageFamilyMemberModal
          familyMember={familyMember}
          show={manageFamilyMember}
          saving={saving}
          handleSaveFamilyMember={handleSaveFamilyMember}
          handleCloseFamilyMember={handleCloseFamilyMember}/>
      }
      {
        memberAccount && <ClientManageAccountModal
          account={memberAccount}
          show={manageMemberAccount}
          saving={saving}
          handleSave={handleSaveMemberAccount}
          handleClose={handleCloseManageAccount}/>
      }

      <MDBox m={1}>&nbsp;</MDBox>
      <Footer/>
    </CustomerPageLayout>
  )
}